import "./Pricing.module.css";
import Header from "@/reusable_sections/Header";
import PricingHero from "./sections/PricingHero";
import PricingCards from "./sections/PricingCards";
import PricingComparison from "./sections/PricingComparison";
import PricingFAQ from "./sections/PricingFAQ";
import PricingCTA from "./sections/PricingCTA";
import Footer from "@/reusable_sections/Footer";
export default function PricingPage() {
  return <div>
      <Header />
      <PricingHero />
      <PricingCards />
      <PricingComparison />
      <PricingFAQ />
      <PricingCTA />
      <Footer />
    </div>;
}